import styled from 'styled-components';
import { Form as FormikForm } from 'formik';
import {
  Card as MuiCard,
  CardContent as MuiCardContent
} from '@material-ui/core';

export const StyledLoginContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

export const StyledLoginCard = styled(MuiCard)`
  display: flex;
  flex-direction: column;
  max-width: 320px;
  width: 80%;
  padding: 40px;
  align-items: center;
  .logo {
    width: 220px;
  }
  h2 {
    margin: 16px 0 36px 0;
    &.message-only {
      margin-bottom: 18px;
    }
  }
  .forgot-password-link {
    cursor: pointer;
    margin: 20px 10px 0px 10px;
  }
  @media screen and (max-width: 480px) {
    padding: 20px;
  }
`;

export const StyledLoginForm = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  width: 100%;
  .form-field {
    margin-bottom: 20px;
  }
  button {
  }
  .error {
    color: red;
    font-size: 12px;
  }
`;

export const StyledLoginCardContent = styled(MuiCardContent)`
  padding: 0;
  text-align: center;
`;
